import * as React from 'react';
import { Tooltip } from '@serodigital/ui-components';

interface ITableTooltipProps {
  label: string;
}

export function TableTooltip({ label }: ITableTooltipProps) {
  return (
    <Tooltip placement="top" hasArrow={true} TooltipComponent={() => <p>{label}</p>}>
      <p className="truncate">{label}</p>
    </Tooltip>
  );
}
